import { render } from "./FileTypeSelection.vue?vue&type=template&id=d7e8c4d2&scoped=true"
import script from "./FileTypeSelection.vue?vue&type=script&lang=js"
export * from "./FileTypeSelection.vue?vue&type=script&lang=js"

import "./FileTypeSelection.vue?vue&type=style&index=0&id=d7e8c4d2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7e8c4d2"]])

export default __exports__